import { render, staticRenderFns } from "./dataAChart.vue?vue&type=template&id=7dff8d08&scoped=true&"
import script from "./dataAChart.vue?vue&type=script&lang=js&"
export * from "./dataAChart.vue?vue&type=script&lang=js&"
import style0 from "./dataAChart.vue?vue&type=style&index=0&id=7dff8d08&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7dff8d08",
  null
  
)

export default component.exports